export const SOCIAL_OVERVIEW_DATA = {
  overview: {
    shareOfVoice: '36%',
    spend: '+117% vs competitors',
    reach: '+158% vs competitors',
    cpm: '~ Same as competitors',
  },
  creativeGallery: {
    items: [
      {
        id: 'american_express_7_image',
        type: 'Image Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_7.jpg',
        cpm: 11.55,
        impressions: '11.2M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_1_image',
        type: 'Image Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_1.jpg',
        cpm: 11.49,
        impressions: '10.9M',
        description: '',
        link: '',
      },
      {
        id: 'chase_5_image',
        type: 'Image Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_5.jpg',
        cpm: 12.24,
        impressions: '10.4M',
        description: '',
        link: '',
      },
      {
        id: 'chase_4_image',
        type: 'Image Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_4.jpg',
        cpm: 12.4,
        impressions: '10.4M',
        description: '',
        link: '',
      },
      {
        id: 'chase_7_image',
        type: 'Image Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_7.jpg',
        cpm: 12.36,
        impressions: '8.7M',
        description: '',
        link: '',
      },
      {
        id: 'chase_6_image',
        type: 'Image Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_6.jpg',
        cpm: 12.29,
        impressions: '8.7M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_16_video',
        type: 'Video Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_16.jpg',
        cpm: 14.85,
        impressions: '8.2M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_2_image',
        type: 'Image Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_2.jpg',
        cpm: 11.66,
        impressions: '8.1M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_15_video',
        type: 'Video Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_15.jpg',
        cpm: 14.84,
        impressions: '7.2M',
        description: '',
        link: '',
      },
      {
        id: 'chase_11_video',
        type: 'Video Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_11.jpg',
        cpm: 16.47,
        impressions: '5.5M',
        description: '',
        link: '',
      },
      {
        id: 'chase_3_image',
        type: 'Image Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_3.jpg',
        cpm: 12.31,
        impressions: '5.5M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_10_video',
        type: 'Video Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_10.jpg',
        cpm: 14.19,
        impressions: '5.5M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_4_image',
        type: 'Image Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_4.jpg',
        cpm: 11.3,
        impressions: '5.4M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_12_video',
        type: 'Video Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_12.jpg',
        cpm: 14.51,
        impressions: '5.3M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_6_image',
        type: 'Image Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_6.jpg',
        cpm: 11.21,
        impressions: '5.0M',
        description: '',
        link: '',
      },
      {
        id: 'chase_13_video',
        type: 'Video Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_13.jpg',
        cpm: 16.24,
        impressions: '4.8M',
        description: '',
        link: '',
      },
      {
        id: 'mastercard_1_image',
        type: 'Image Post',
        brandName: 'Mastercard',
        brandLogo: '',
        brandColor: '#EB001B',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/mastercard_1.jpg',
        cpm: 12.18,
        impressions: '4.6M',
        description: '',
        link: '',
      },
      {
        id: 'chase_9_video',
        type: 'Video Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_9.jpg',
        cpm: 16.1,
        impressions: '4.5M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_9_video',
        type: 'Video Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_9.jpg',
        cpm: 14.63,
        impressions: '3.6M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_3_image',
        type: 'Image Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_3.jpg',
        cpm: 11.12,
        impressions: '3.5M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_14_video',
        type: 'Video Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_14.jpg',
        cpm: 15.14,
        impressions: '3.5M',
        description: '',
        link: '',
      },
      {
        id: 'chase_8_image',
        type: 'Image Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_8.jpg',
        cpm: 11.03,
        impressions: '3.4M',
        description: '',
        link: '',
      },
      {
        id: 'chase_2_image',
        type: 'Image Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_2.jpg',
        cpm: 10.67,
        impressions: '3.4M',
        description: '',
        link: '',
      },
      {
        id: 'discover_6_image',
        type: 'Image Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_6.jpg',
        cpm: 12.57,
        impressions: '2.8M',
        description: '',
        link: '',
      },
      {
        id: 'discover_3_image',
        type: 'Image Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_3.jpg',
        cpm: 12.65,
        impressions: '2.7M',
        description: '',
        link: '',
      },
      {
        id: 'chase_12_video',
        type: 'Video Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_12.jpg',
        cpm: 18.09,
        impressions: '2.6M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_8_image',
        type: 'Image Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_8.jpg',
        cpm: 11.36,
        impressions: '2.4M',
        description: '',
        link: '',
      },
      {
        id: 'discover_4_image',
        type: 'Image Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_4.jpg',
        cpm: 12.62,
        impressions: '2.4M',
        description: '',
        link: '',
      },
      {
        id: 'chase_16_video',
        type: 'Video Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_16.jpg',
        cpm: 16,
        impressions: '2.2M',
        description: '',
        link: '',
      },
      {
        id: 'chase_10_video',
        type: 'Video Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_10.jpg',
        cpm: 15.83,
        impressions: '2.1M',
        description: '',
        link: '',
      },
      {
        id: 'mastercard_3_image',
        type: 'Image Post',
        brandName: 'Mastercard',
        brandLogo: '',
        brandColor: '#EB001B',
        platform: 'Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/mastercard_3.jpg',
        cpm: 13.42,
        impressions: '1.9M',
        description: '',
        link: '',
      },
      {
        id: 'chase_15_video',
        type: 'Video Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_15.jpg',
        cpm: 16.71,
        impressions: '1.8M',
        description: '',
        link: '',
      },
      {
        id: 'visa_10_video',
        type: 'Video Post',
        brandName: 'Visa',
        brandLogo: '',
        brandColor: '#1A1F71',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/visa_10.jpg',
        cpm: 15.07,
        impressions: '1.8M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_13_video',
        type: 'Video Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_13.jpg',
        cpm: 14.78,
        impressions: '1.8M',
        description: '',
        link: '',
      },
      {
        id: 'discover_13_video',
        type: 'Video Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_13.jpg',
        cpm: 16.4,
        impressions: '1.7M',
        description: '',
        link: '',
      },
      {
        id: 'mastercard_2_image',
        type: 'Image Post',
        brandName: 'Mastercard',
        brandLogo: '',
        brandColor: '#EB001B',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/mastercard_2.jpg',
        cpm: 12.31,
        impressions: '1.6M',
        description: '',
        link: '',
      },
      {
        id: 'discover_2_image',
        type: 'Image Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_2.jpg',
        cpm: 12.65,
        impressions: '1.6M',
        description: '',
        link: '',
      },
      {
        id: 'discover_15_video',
        type: 'Video Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_15.jpg',
        cpm: 16.3,
        impressions: '1.5M',
        description: '',
        link: '',
      },
      {
        id: 'mastercard_10_video',
        type: 'Video Post',
        brandName: 'Mastercard',
        brandLogo: '',
        brandColor: '#EB001B',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/mastercard_10.jpg',
        cpm: 15.57,
        impressions: '1.3M',
        description: '',
        link: '',
      },
      {
        id: 'american_express_11_video',
        type: 'Video Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_11.jpg',
        cpm: 18.39,
        impressions: '1.2M',
        description: '',
        link: '',
      },
      {
        id: 'visa_12_video',
        type: 'Video Post',
        brandName: 'Visa',
        brandLogo: '',
        brandColor: '#1A1F71',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/visa_12.jpg',
        cpm: 15.24,
        impressions: '1.1M',
        description: '',
        link: '',
      },
      {
        id: 'discover_7_image',
        type: 'Image Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_7.jpg',
        cpm: 13.6,
        impressions: '1.0M',
        description: '',
        link: '',
      },
      {
        id: 'mastercard_12_video',
        type: 'Video Post',
        brandName: 'Mastercard',
        brandLogo: '',
        brandColor: '#EB001B',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/mastercard_12.jpg',
        cpm: 15.69,
        impressions: '1.0M',
        description: '',
        link: '',
      },
      {
        id: 'discover_8_image',
        type: 'Image Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_8.jpg',
        cpm: 12.67,
        impressions: '1.0M',
        description: '',
        link: '',
      },
      {
        id: 'discover_5_image',
        type: 'Image Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_5.jpg',
        cpm: 13.74,
        impressions: '989K',
        description: '',
        link: '',
      },
      {
        id: 'american_express_5_image',
        type: 'Image Post',
        brandName: 'American Express',
        brandLogo: '',
        brandColor: '#016FD0',
        platform: 'Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/american_express_5.jpg',
        cpm: 14.01,
        impressions: '969K',
        description: '',
        link: '',
      },
      {
        id: 'discover_10_video',
        type: 'Video Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_10.jpg',
        cpm: 13.87,
        impressions: '646K',
        description: '',
        link: '',
      },
      {
        id: 'discover_14_video',
        type: 'Video Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_14.jpg',
        cpm: 16.63,
        impressions: '646K',
        description: '',
        link: '',
      },
      {
        id: 'visa_9_video',
        type: 'Video Post',
        brandName: 'Visa',
        brandLogo: '',
        brandColor: '#1A1F71',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/visa_9.jpg',
        cpm: 15.05,
        impressions: '635K',
        description: '',
        link: '',
      },
      {
        id: 'mastercard_9_video',
        type: 'Video Post',
        brandName: 'Mastercard',
        brandLogo: '',
        brandColor: '#EB001B',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/mastercard_9.jpg',
        cpm: 15.65,
        impressions: '556K',
        description: '',
        link: '',
      },
      {
        id: 'discover_12_video',
        type: 'Video Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_12.jpg',
        cpm: 14.13,
        impressions: '532K',
        description: '',
        link: '',
      },
      {
        id: 'discover_1_image',
        type: 'Image Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_1.jpg',
        cpm: 12.59,
        impressions: '492K',
        description: '',
        link: '',
      },
      {
        id: 'mastercard_13_video',
        type: 'Video Post',
        brandName: 'Mastercard',
        brandLogo: '',
        brandColor: '#EB001B',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/mastercard_13.jpg',
        cpm: 15.53,
        impressions: '478K',
        description: '',
        link: '',
      },
      {
        id: 'discover_9_video',
        type: 'Video Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_9.jpg',
        cpm: 16.49,
        impressions: '442K',
        description: '',
        link: '',
      },
      {
        id: 'discover_16_video',
        type: 'Video Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_16.jpg',
        cpm: 16.4,
        impressions: '404K',
        description: '',
        link: '',
      },
      {
        id: 'visa_11_video',
        type: 'Video Post',
        brandName: 'Visa',
        brandLogo: '',
        brandColor: '#1A1F71',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/visa_11.jpg',
        cpm: 15.24,
        impressions: '393K',
        description: '',
        link: '',
      },
      {
        id: 'mastercard_11_video',
        type: 'Video Post',
        brandName: 'Mastercard',
        brandLogo: '',
        brandColor: '#EB001B',
        platform: 'Facebook & Instagram',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/mastercard_11.jpg',
        cpm: 15.98,
        impressions: '338K',
        description: '',
        link: '',
      },
      {
        id: 'chase_14_video',
        type: 'Video Post',
        brandName: 'Chase',
        brandLogo: '',
        brandColor: '#0A5C96',
        platform: 'Facebook',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/chase_14.jpg',
        cpm: 13.77,
        impressions: '315K',
        description: '',
        link: '',
      },
      {
        id: 'discover_11_video',
        type: 'Video Post',
        brandName: 'Discover',
        brandLogo: '',
        brandColor: '#FF6000',
        platform: 'Facebook',
        platformIcon: '',
        imgUrl: 'mock-assets/social-creatives/Social Creatives/discover_11.jpg',
        cpm: 14,
        impressions: '177K',
        description: '',
        link: '',
      },
    ],
    total: 59,
  },
  shareOfVoice: [
    { name: 'American Express', share: 35.57, color: '#016FD0' },
    { name: 'Chase', share: 31.92, color: '#0A5C96' },
    { name: 'Visa', share: 12.7, color: '#1A1F71' },
    { name: 'Mastercard', share: 11.71, color: '#EB001B' },
    { name: 'Discover', share: 8.11, color: '#FF6000' },
  ],
  performanceOverTime: [
    {
      name: 'American Express',
      data: [
        { date: '2026-02-01', spend: 14209.28, impressions: 908083, reach: 455787, cpm: 13.04 },
        { date: '2026-02-02', spend: 61832.04, impressions: 3964108, reach: 1984112, cpm: 13 },
        { date: '2026-02-03', spend: 54441.53, impressions: 3475636, reach: 1751281, cpm: 13.04 },
        { date: '2026-02-04', spend: 38652.63, impressions: 2541526, reach: 1273556, cpm: 12.67 },
        { date: '2026-02-05', spend: 38513.7, impressions: 2482901, reach: 1244134, cpm: 12.93 },
        { date: '2026-02-06', spend: 69767.01, impressions: 4394873, reach: 2196488, cpm: 13.23 },
        { date: '2026-02-07', spend: 12957.34, impressions: 855302, reach: 427484, cpm: 12.63 },
        { date: '2026-02-08', spend: 55912.15, impressions: 3620425, reach: 1812191, cpm: 12.87 },
        { date: '2026-02-09', spend: 22764.13, impressions: 1443294, reach: 726831, cpm: 13.15 },
        { date: '2026-02-10', spend: 13846.64, impressions: 916353, reach: 461063, cpm: 12.6 },
        { date: '2026-02-11', spend: 44382.61, impressions: 2929689, reach: 1469894, cpm: 12.63 },
        { date: '2026-02-12', spend: 76445.62, impressions: 4980656, reach: 2511107, cpm: 12.8 },
        { date: '2026-02-13', spend: 60407.49, impressions: 3876752, reach: 1947383, cpm: 12.98 },
        { date: '2026-02-14', spend: 59701.96, impressions: 3836843, reach: 1925174, cpm: 12.97 },
        { date: '2026-02-15', spend: 57909.08, impressions: 3767904, reach: 1890527, cpm: 12.81 },
        { date: '2026-02-16', spend: 63584.5, impressions: 4032168, reach: 2028411, cpm: 13.16 },
        { date: '2026-02-17', spend: 44081.04, impressions: 2871343, reach: 1436223, cpm: 12.8 },
        { date: '2026-02-18', spend: 16472.42, impressions: 1061135, reach: 530277, cpm: 12.95 },
        { date: '2026-02-19', spend: 66038.56, impressions: 4280115, reach: 2159619, cpm: 12.84 },
        { date: '2026-02-20', spend: 39983.2, impressions: 2534404, reach: 1270896, cpm: 13.13 },
        { date: '2026-02-21', spend: 43599.63, impressions: 2841709, reach: 1433166, cpm: 12.78 },
        { date: '2026-02-22', spend: 33886.1, impressions: 2157925, reach: 1080797, cpm: 13.08 },
        { date: '2026-02-23', spend: 21476.96, impressions: 1378714, reach: 694976, cpm: 12.98 },
        { date: '2026-02-24', spend: 74661.2, impressions: 4710783, reach: 2361558, cpm: 13.21 },
        { date: '2026-02-25', spend: 62075.54, impressions: 4029764, reach: 2025119, cpm: 12.84 },
        { date: '2026-02-26', spend: 51567.46, impressions: 3378940, reach: 1700539, cpm: 12.72 },
        { date: '2026-02-27', spend: 35621.6, impressions: 2274602, reach: 1140073, cpm: 13.04 },
        { date: '2026-02-28', spend: 66856.85, impressions: 4294265, reach: 2152302, cpm: 12.98 },
      ],
    },
    {
      name: 'Chase',
      data: [
        { date: '2026-02-01', spend: 13361.39, impressions: 828175, reach: 356038, cpm: 13.44 },
        { date: '2026-02-02', spend: 58400.64, impressions: 3549452, reach: 1539994, cpm: 13.71 },
        { date: '2026-02-03', spend: 49728.97, impressions: 3051631, reach: 1320361, cpm: 13.57 },
        { date: '2026-02-04', spend: 35798.05, impressions: 2246877, reach: 970858, cpm: 13.27 },
        { date: '2026-02-05', spend: 36042.61, impressions: 2209772, reach: 956728, cpm: 13.59 },
        { date: '2026-02-06', spend: 64738.95, impressions: 4035009, reach: 1748395, cpm: 13.36 },
        { date: '2026-02-07', spend: 13383.05, impressions: 802785, reach: 346272, cpm: 13.88 },
        { date: '2026-02-08', spend: 52946.01, impressions: 3254819, reach: 1405356, cpm: 13.54 },
        { date: '2026-02-09', spend: 20689.31, impressions: 1257632, reach: 543182, cpm: 13.72 },
        { date: '2026-02-10', spend: 14196.19, impressions: 844006, reach: 363669, cpm: 14.03 },
        { date: '2026-02-11', spend: 42397.61, impressions: 2625733, reach: 1136275, cpm: 13.47 },
        { date: '2026-02-12', spend: 70471.37, impressions: 4443246, reach: 1917103, cpm: 13.21 },
        { date: '2026-02-13', spend: 56289.17, impressions: 3481062, reach: 1502506, cpm: 13.47 },
        { date: '2026-02-14', spend: 57647.23, impressions: 3488748, reach: 1503923, cpm: 13.76 },
        { date: '2026-02-15', spend: 53702.59, impressions: 3326290, reach: 1439279, cpm: 13.43 },
        { date: '2026-02-16', spend: 56746.53, impressions: 3581568, reach: 1553292, cpm: 13.19 },
        { date: '2026-02-17', spend: 41241.01, impressions: 2563066, reach: 1105831, cpm: 13.4 },
        { date: '2026-02-18', spend: 15570.34, impressions: 973529, reach: 419584, cpm: 13.33 },
        { date: '2026-02-19', spend: 62376.71, impressions: 3881631, reach: 1680000, cpm: 13.39 },
        { date: '2026-02-20', spend: 37727.17, impressions: 2315001, reach: 997257, cpm: 13.58 },
        { date: '2026-02-21', spend: 41017.82, impressions: 2479952, reach: 1075177, cpm: 13.77 },
        { date: '2026-02-22', spend: 32098.5, impressions: 1938833, reach: 841212, cpm: 13.8 },
        { date: '2026-02-23', spend: 18649.57, impressions: 1174863, reach: 507032, cpm: 13.22 },
        { date: '2026-02-24', spend: 68219.81, impressions: 4176616, reach: 1809815, cpm: 13.63 },
        { date: '2026-02-25', spend: 58311.86, impressions: 3661690, reach: 1580333, cpm: 13.3 },
        { date: '2026-02-26', spend: 50542.8, impressions: 3065479, reach: 1323800, cpm: 13.72 },
        { date: '2026-02-27', spend: 35748.03, impressions: 2149142, reach: 925684, cpm: 13.85 },
        { date: '2026-02-28', spend: 61520.71, impressions: 3829020, reach: 1658043, cpm: 13.39 },
      ],
    },
    {
      name: 'Visa',
      data: [
        { date: '2026-02-01', spend: 4793.07, impressions: 324501, reach: 143615, cpm: 12.32 },
        { date: '2026-02-02', spend: 20691.73, impressions: 1437049, reach: 634721, cpm: 12 },
        { date: '2026-02-03', spend: 18751.73, impressions: 1235782, reach: 544634, cpm: 12.64 },
        { date: '2026-02-04', spend: 13338.31, impressions: 911507, reach: 404199, cpm: 12.2 },
        { date: '2026-02-05', spend: 12719.31, impressions: 866656, reach: 383148, cpm: 12.25 },
        { date: '2026-02-06', spend: 23710.5, impressions: 1565753, reach: 694989, cpm: 12.64 },
        { date: '2026-02-07', spend: 4666.56, impressions: 319228, reach: 141628, cpm: 12.18 },
        { date: '2026-02-08', spend: 18665.03, impressions: 1277194, reach: 568072, cpm: 12.18 },
        { date: '2026-02-09', spend: 7770.5, impressions: 527054, reach: 233179, cpm: 12.27 },
        { date: '2026-02-10', spend: 5034.36, impressions: 336761, reach: 148762, cpm: 12.48 },
        { date: '2026-02-11', spend: 15263.29, impressions: 1013026, reach: 446308, cpm: 12.54 },
        { date: '2026-02-12', spend: 26549.72, impressions: 1788473, reach: 793432, cpm: 12.38 },
        { date: '2026-02-13', spend: 20307.18, impressions: 1388760, reach: 616778, cpm: 12.17 },
        { date: '2026-02-14', spend: 20502.2, impressions: 1374038, reach: 606628, cpm: 12.43 },
        { date: '2026-02-15', spend: 19193.39, impressions: 1347001, reach: 597732, cpm: 11.88 },
        { date: '2026-02-16', spend: 21190.6, impressions: 1440068, reach: 638304, cpm: 12.25 },
        { date: '2026-02-17', spend: 15221.01, impressions: 1010302, reach: 448847, cpm: 12.55 },
        { date: '2026-02-18', spend: 5654.56, impressions: 388153, reach: 171413, cpm: 12.11 },
        { date: '2026-02-19', spend: 21761, impressions: 1508758, reach: 668110, cpm: 12.02 },
        { date: '2026-02-20', spend: 13047.82, impressions: 912668, reach: 405244, cpm: 11.93 },
        { date: '2026-02-21', spend: 13854.09, impressions: 979238, reach: 433542, cpm: 11.8 },
        { date: '2026-02-22', spend: 11772.84, impressions: 776397, reach: 344520, cpm: 12.66 },
        { date: '2026-02-23', spend: 6825.49, impressions: 465497, reach: 205831, cpm: 12.21 },
        { date: '2026-02-24', spend: 24272.04, impressions: 1693476, reach: 750273, cpm: 11.94 },
        { date: '2026-02-25', spend: 21519.08, impressions: 1457116, reach: 643100, cpm: 12.31 },
        { date: '2026-02-26', spend: 18252.87, impressions: 1222080, reach: 540957, cpm: 12.44 },
        { date: '2026-02-27', spend: 12125.24, impressions: 818660, reach: 360924, cpm: 12.35 },
        { date: '2026-02-28', spend: 22826.75, impressions: 1550866, reach: 691076, cpm: 12.26 },
      ],
    },
    {
      name: 'Mastercard',
      data: [
        { date: '2026-02-01', spend: 4610.69, impressions: 296258, reach: 125113, cpm: 12.96 },
        { date: '2026-02-02', spend: 19773.44, impressions: 1323083, reach: 564056, cpm: 12.45 },
        { date: '2026-02-03', spend: 18097.7, impressions: 1151811, reach: 491378, cpm: 13.07 },
        { date: '2026-02-04', spend: 12702.47, impressions: 812986, reach: 345368, cpm: 13.03 },
        { date: '2026-02-05', spend: 12335.98, impressions: 819281, reach: 348834, cpm: 12.53 },
        { date: '2026-02-06', spend: 22575.02, impressions: 1445825, reach: 613011, cpm: 13.01 },
        { date: '2026-02-07', spend: 4343.31, impressions: 293458, reach: 124707, cpm: 12.33 },
        { date: '2026-02-08', spend: 18786.12, impressions: 1211544, reach: 516443, cpm: 12.92 },
        { date: '2026-02-09', spend: 7224.83, impressions: 464249, reach: 196154, cpm: 12.97 },
        { date: '2026-02-10', spend: 4959.18, impressions: 311619, reach: 131909, cpm: 13.25 },
        { date: '2026-02-11', spend: 14240.88, impressions: 940289, reach: 399115, cpm: 12.62 },
        { date: '2026-02-12', spend: 24874.05, impressions: 1604636, reach: 682119, cpm: 12.92 },
        { date: '2026-02-13', spend: 18761.77, impressions: 1269250, reach: 541446, cpm: 12.31 },
        { date: '2026-02-14', spend: 20398.11, impressions: 1314239, reach: 558119, cpm: 12.92 },
        { date: '2026-02-15', spend: 18758.92, impressions: 1236483, reach: 526230, cpm: 12.63 },
        { date: '2026-02-16', spend: 20460.6, impressions: 1344743, reach: 571503, cpm: 12.67 },
        { date: '2026-02-17', spend: 13835.05, impressions: 922530, reach: 389676, cpm: 12.49 },
        { date: '2026-02-18', spend: 5426.28, impressions: 357001, reach: 152286, cpm: 12.64 },
        { date: '2026-02-19', spend: 21276.03, impressions: 1377346, reach: 586130, cpm: 12.88 },
        { date: '2026-02-20', spend: 12647.32, impressions: 838640, reach: 356781, cpm: 12.57 },
        { date: '2026-02-21', spend: 14060.19, impressions: 934432, reach: 398997, cpm: 12.54 },
        { date: '2026-02-22', spend: 11037.69, impressions: 712235, reach: 302551, cpm: 12.92 },
        { date: '2026-02-23', spend: 6916.15, impressions: 447866, reach: 189914, cpm: 12.87 },
        { date: '2026-02-24', spend: 24573.39, impressions: 1582073, reach: 672109, cpm: 12.95 },
        { date: '2026-02-25', spend: 20789.86, impressions: 1339226, reach: 568855, cpm: 12.92 },
        { date: '2026-02-26', spend: 17299.08, impressions: 1120672, reach: 477236, cpm: 12.85 },
        { date: '2026-02-27', spend: 11719.34, impressions: 756886, reach: 323541, cpm: 12.9 },
        { date: '2026-02-28', spend: 21465.59, impressions: 1375798, reach: 587799, cpm: 13.01 },
      ],
    },
    {
      name: 'Discover',
      data: [
        { date: '2026-02-01', spend: 3338.32, impressions: 202881, reach: 80989, cpm: 13.69 },
        { date: '2026-02-02', spend: 15557.04, impressions: 919004, reach: 368288, cpm: 14.11 },
        { date: '2026-02-03', spend: 13246.75, impressions: 813102, reach: 323815, cpm: 13.56 },
        { date: '2026-02-04', spend: 9506.83, impressions: 571757, reach: 227403, cpm: 13.86 },
        { date: '2026-02-05', spend: 9297.31, impressions: 558126, reach: 222664, cpm: 13.88 },
        { date: '2026-02-06', spend: 16357.25, impressions: 1001560, reach: 401732, cpm: 13.61 },
        { date: '2026-02-07', spend: 3385.08, impressions: 205059, reach: 81088, cpm: 13.75 },
        { date: '2026-02-08', spend: 13296.43, impressions: 827297, reach: 330533, cpm: 13.38 },
        { date: '2026-02-09', spend: 5334.31, impressions: 319379, reach: 125923, cpm: 13.9 },
        { date: '2026-02-10', spend: 3594.32, impressions: 213340, reach: 84207, cpm: 14.05 },
        { date: '2026-02-11', spend: 10683.49, impressions: 657516, reach: 261384, cpm: 13.55 },
        { date: '2026-02-12', spend: 18507.04, impressions: 1099232, reach: 439038, cpm: 14.04 },
        { date: '2026-02-13', spend: 14264.49, impressions: 882089, reach: 351294, cpm: 13.49 },
        { date: '2026-02-14', spend: 15207.19, impressions: 898476, reach: 358299, cpm: 14.11 },
        { date: '2026-02-15', spend: 13287.02, impressions: 837559, reach: 334650, cpm: 13.2 },
        { date: '2026-02-16', spend: 15441.89, impressions: 935174, reach: 372464, cpm: 13.76 },
        { date: '2026-02-17', spend: 10572.56, impressions: 644290, reach: 256870, cpm: 13.67 },
        { date: '2026-02-18', spend: 4049.87, impressions: 247241, reach: 97716, cpm: 13.63 },
        { date: '2026-02-19', spend: 15730.02, impressions: 962403, reach: 384719, cpm: 13.63 },
        { date: '2026-02-20', spend: 9726.59, impressions: 590527, reach: 235391, cpm: 13.74 },
        { date: '2026-02-21', spend: 10724.26, impressions: 643224, reach: 255182, cpm: 13.88 },
        { date: '2026-02-22', spend: 8136.96, impressions: 498434, reach: 199306, cpm: 13.6 },
        { date: '2026-02-23', spend: 5048.8, impressions: 304090, reach: 120807, cpm: 13.83 },
        { date: '2026-02-24', spend: 18825.29, impressions: 1091702, reach: 434574, cpm: 14.36 },
        { date: '2026-02-25', spend: 14875.51, impressions: 920075, reach: 364835, cpm: 13.49 },
        { date: '2026-02-26', spend: 13338.34, impressions: 790362, reach: 314742, cpm: 14.07 },
        { date: '2026-02-27', spend: 8530.43, impressions: 520757, reach: 208629, cpm: 13.64 },
        { date: '2026-02-28', spend: 15959.75, impressions: 961308, reach: 382359, cpm: 13.83 },
      ],
    },
  ],
  channelDistribution: [
    {
      brandName: 'American Express',
      brandLogo: '',
      segments: [
        { label: 'Facebook', percentage: 82.2, color: '#1877F2' },
        { label: 'Instagram', percentage: 17.8, color: '#E4405F' },
      ],
    },
    {
      brandName: 'Chase',
      brandLogo: '',
      segments: [
        { label: 'Facebook', percentage: 46.5, color: '#1877F2' },
        { label: 'Instagram', percentage: 53.5, color: '#E4405F' },
      ],
    },
    {
      brandName: 'Visa',
      brandLogo: '',
      segments: [
        { label: 'Facebook', percentage: 77.6, color: '#1877F2' },
        { label: 'Instagram', percentage: 22.4, color: '#E4405F' },
      ],
    },
    {
      brandName: 'Mastercard',
      brandLogo: '',
      segments: [
        { label: 'Facebook', percentage: 61.9, color: '#1877F2' },
        { label: 'Instagram', percentage: 38.1, color: '#E4405F' },
      ],
    },
    {
      brandName: 'Discover',
      brandLogo: '',
      segments: [
        { label: 'Facebook', percentage: 39.4, color: '#1877F2' },
        { label: 'Instagram', percentage: 60.6, color: '#E4405F' },
      ],
    },
  ],
  adType: [
    {
      label: 'Image',
      brands: [
        { brandName: 'American Express', brandLogo: '', percentage: 56.7 },
        { brandName: 'Chase', brandLogo: '', percentage: 68.1 },
        { brandName: 'Visa', brandLogo: '', percentage: 82.8 },
        { brandName: 'Mastercard', brandLogo: '', percentage: 78.5 },
        { brandName: 'Discover', brandLogo: '', percentage: 68.1 },
      ],
    },
    {
      label: 'Video',
      brands: [
        { brandName: 'American Express', brandLogo: '', percentage: 43.3 },
        { brandName: 'Chase', brandLogo: '', percentage: 31.9 },
        { brandName: 'Visa', brandLogo: '', percentage: 17.2 },
        { brandName: 'Mastercard', brandLogo: '', percentage: 21.5 },
        { brandName: 'Discover', brandLogo: '', percentage: 31.9 },
      ],
    },
  ],
  performanceMap: [
    { region: 'AK', spend: 8068.2, impressions: 522403, reach: 226601, cpm: 12.86 },
    { region: 'AL', spend: 56843.44, impressions: 3597265, reach: 1589771, cpm: 13.17 },
    { region: 'AR', spend: 33755.27, impressions: 2136725, reach: 939173, cpm: 13.17 },
    { region: 'AZ', spend: 82367.12, impressions: 5309580, reach: 2371449, cpm: 12.93 },
    { region: 'CA', spend: 429911.41, impressions: 27245858, reach: 13172935, cpm: 13.15 },
    { region: 'CO', spend: 65817.56, impressions: 4138070, reach: 1840535, cpm: 13.25 },
    { region: 'CT', spend: 39704.88, impressions: 2562306, reach: 1128916, cpm: 12.91 },
    { region: 'DE', spend: 11439.87, impressions: 731000, reach: 318287, cpm: 13.03 },
    { region: 'FL', spend: 254859.95, impressions: 16315772, reach: 7600267, cpm: 13.01 },
    { region: 'GA', spend: 121315.92, impressions: 7802690, reach: 3503197, cpm: 12.95 },
    { region: 'HI', spend: 15798.98, impressions: 1020358, reach: 446809, cpm: 12.9 },
    { region: 'IA', spend: 35206.07, impressions: 2248747, reach: 988719, cpm: 13.05 },
    { region: 'ID', spend: 21440.12, impressions: 1389392, reach: 609396, cpm: 12.85 },
    { region: 'IL', spend: 138984.58, impressions: 8877861, reach: 4008223, cpm: 13.05 },
    { region: 'IN', spend: 75477.54, impressions: 4815299, reach: 2150303, cpm: 13.06 },
    { region: 'KS', spend: 32573.74, impressions: 2076880, reach: 911750, cpm: 13.07 },
    { region: 'KY', spend: 50935.53, impressions: 3233293, reach: 1431247, cpm: 13.13 },
    { region: 'LA', spend: 49917.8, impressions: 3188289, reach: 1411011, cpm: 13.04 },
    { region: 'MA', spend: 77043.74, impressions: 4918934, reach: 2188516, cpm: 13.05 },
    { region: 'MD', spend: 67982.82, impressions: 4363512, reach: 1939646, cpm: 12.98 },
    { region: 'ME', spend: 15277.62, impressions: 968341, reach: 423872, cpm: 13.14 },
    { region: 'MI', spend: 108617.62, impressions: 7070422, reach: 3181184, cpm: 12.8 },
    { region: 'MN', spend: 63534.87, impressions: 4015582, reach: 1782297, cpm: 13.19 },
    { region: 'MO', spend: 68982.86, impressions: 4342948, reach: 1927575, cpm: 13.23 },
    { region: 'MS', spend: 32087.97, impressions: 2047458, reach: 901454, cpm: 13.06 },
    { region: 'MT', spend: 12104.87, impressions: 770453, reach: 335475, cpm: 13.09 },
    { region: 'NC', spend: 122074.52, impressions: 7730789, reach: 3471164, cpm: 13.16 },
    { region: 'ND', spend: 8532.31, impressions: 544875, reach: 236687, cpm: 13.05 },
    { region: 'NE', spend: 21922.52, impressions: 1401503, reach: 612988, cpm: 13.03 },
    { region: 'NH', spend: 15293.14, impressions: 974931, reach: 426409, cpm: 13.08 },
    { region: 'NJ', spend: 102785.72, impressions: 6563584, reach: 2939788, cpm: 13.05 },
    { region: 'NM', spend: 22975.85, impressions: 1467795, reach: 643156, cpm: 13.05 },
    { region: 'NV', spend: 35946.8, impressions: 2265399, reach: 997741, cpm: 13.23 },
    { region: 'NY', spend: 218194.22, impressions: 13784833, reach: 6357167, cpm: 13.19 },
    { region: 'OH', spend: 129615.86, impressions: 8246268, reach: 3714236, cpm: 13.1 },
    { region: 'OK', spend: 44100.19, impressions: 2822189, reach: 1243226, cpm: 13.02 },
    { region: 'OR', spend: 47281.59, impressions: 2982711, reach: 1318719, cpm: 13.21 },
    { region: 'PA', spend: 141934.74, impressions: 9148380, reach: 4127792, cpm: 12.93 },
    { region: 'RI', spend: 12051.47, impressions: 768759, reach: 335396, cpm: 13.05 },
    { region: 'SC', spend: 60020.61, impressions: 3807171, reach: 1685879, cpm: 13.14 },
    { region: 'SD', spend: 9930.39, impressions: 636629, reach: 276886, cpm: 12.99 },
    { region: 'TN', spend: 77416.4, impressions: 4998889, reach: 2227999, cpm: 12.91 },
    { region: 'TX', spend: 341713.74, impressions: 21561610, reach: 10264380, cpm: 13.19 },
    { region: 'UT', spend: 37877.31, impressions: 2434575, reach: 1075438, cpm: 12.97 },
    { region: 'VA', spend: 96487.39, impressions: 6115652, reach: 2738870, cpm: 13.15 },
    { region: 'VT', spend: 7038.86, impressions: 447949, reach: 193963, cpm: 13.1 },
    { region: 'WA', spend: 88340.34, impressions: 5590846, reach: 2493399, cpm: 13.17 },
    { region: 'WI', spend: 64143.32, impressions: 4096058, reach: 1816223, cpm: 13.04 },
    { region: 'WV', spend: 19305.73, impressions: 1230920, reach: 538991, cpm: 13.08 },
    { region: 'WY', spend: 6231.35, impressions: 400571, reach: 173109, cpm: 12.96 },
  ],
} as const;
